import type { Map } from "ol";
import { getGeoMarkerLayer } from "../../layers";
import { fromLonLat } from "ol/proj";

//Перемещение на местоположение браузера
export function activateAddGeoMarkersFunction(positionsOfGeoMarkers: any, map?: Map) {
    const geoMarkerLayer = getGeoMarkerLayer();
    positionsOfGeoMarkers.map((geoMarkerPosition: any) => {
        const { longitude, latitude } = geoMarkerPosition ?? {}
        const coordinates = fromLonLat([longitude, latitude]);
        geoMarkerLayer?.getSource()?.getFeatures()[0]?.getGeometry()?.setCoordinates(coordinates);
        map?.addLayer(geoMarkerLayer)
    })

    return {
        off: () => {
            map?.removeLayer(geoMarkerLayer);
        }
    };
}